/**
 * Role normalization — align with backend utils/roles.js
 */
export function normalizeRole(role) {
  if (!role || role === 'user') return 'client';
  return role;
}

export function isAdmin(profile) {
  return normalizeRole(profile?.role) === 'admin';
}

export function isChef(profile) {
  return normalizeRole(profile?.role) === 'chef';
}

export function isAdminOrChef(profile) {
  const role = normalizeRole(profile?.role);
  return role === 'admin' || role === 'chef';
}

export function isClient(profile) {
  return normalizeRole(profile?.role) === 'client';
}
